<template>
    <!-- <el-card class="card-wrap"> -->
        <div class="wrap" style="padding: 0px;">
            <div class="wrap-top">
                <div class="wrap-top-for" v-for="(item, index) in dataArray" :key="index">
                    <div class="wrap-top-for-flex">
                        <div class="left-div">
                            <img :src="item.logo" />
                        </div>
                        <div class="right-div">
                            <div class="right-div-wrap" v-if="lan == 'ch'">
                                <p class="right-div-wrap-title">{{item.company}}</p>
                                <p class="right-div-wrap-content">{{item.intro}}</p>
                                <div class="right-div-wrap-div" @click="handleInternationalFairGuestDetail(item)">查看详情</div>
                            </div>
                            
                            <div class="right-div-wrap" v-if="lan == 'en'">
                                <p class="right-div-wrap-title">{{item.company_en}}</p>
                                <p class="right-div-wrap-content">{{item.intro_en}}</p>
                                <div class="right-div-wrap-div" @click="handleInternationalFairGuestDetail(item)">Details</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "../../../common/cookie";
import { language } from "../../../language/get";
import { getUserInfo } from "../../../api/user";
const lan = language();
export default {
  computed: {
    ...mapGetters(["token"])
  },
  props: {
    dataArray: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      formLabelAlign: {
          companyName: '',
          trueName: '',
          userPost: '',
          phone: '',
          email:'',
      },
      isWiffa: 'true',
      lan: Cookies.get("lang"),
      language: lan,

    };
  },
  mounted() {
    //   this.userInfo();
  },
  
  methods: {
      userInfo() {
      let data = {
        token: this.$store.state.user.token
      };
      getUserInfo(data).then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            return this.$message.error({message: res.text, offset: 120})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
          this.formLabelAlign.companyName = res.data[0].company;
      });
    },

    handleInternationalFairGuestDetail(item){
        this.$emit("handleInternationalFairGuestDetail", item);
    },
    
  },
};
</script>

<style scoped>
/* .card-wrap{
    width: 99%;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
} */
.wrap{
    width:100%;
    /* width: 1200px; */
    margin: auto;
    min-height: 700px;
    /* padding-bottom: 30px; */
    /* background: #ececec; */
    /* -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}
.wrap-top{
    /* width: 1200px; */
    margin: 10px auto 0px;
    /* text-align: center; */
    /* border: 1px solid #ff3900; */
    border-radius: 5px;
    padding: 20px 0 0;
}
/* .wrap-top div:nth-child(2n-1){
    margin-right: 10px;
}

.wrap-top div:nth-child(2n){
    margin-left: 10px;
} */
.wrap-top div{
    margin:0 10px 20px;
}

.wrap-top div:nth-child(1){
    margin-left: 0px;
}
.wrap-top div:nth-child(6){
    margin-left: 0px;
}

.wrap-top div:nth-child(10){
    margin-right: 0px;
}
.wrap-top-for{
    display: inline-block;
    /* width: 549px; */
    width: 206px;
    height: 300px;
    background: #fff;
    /* margin-top: 10px; */
    margin-bottom: 20px;
    -webkit-box-shadow: 0 2px 6px 0 rgba(156, 156, 156, 0.55);
    box-shadow: 0 2px 6px 0 rgba(156, 156, 156, 0.55);

}
.wrap-top-for-flex{
    /* display:flex; */
    margin-right: 0px !important;
}
.left-div{
    /* height: 100px; */
    padding-top: 30px;
    text-align: center;
    margin: 0 auto;
    /* display:inline-flex;
    align-items: center;
    justify-items: center; */
}
.left-div img{
    margin:0 0 0 20px;
    width:80px !important;
    height:80px !important;
    display:inline-flex;
    align-items: center;
    justify-items: center;
}
.right-div{
    /* width: 420px; */
    height:150px;
    margin: 0 auto;
    /* display:inline-flex;
    align-items: center;
    justify-items: center; */
    text-align: center;
}
.right-div-wrap{
    margin-right: 0 !important;
}
.right-div-wrap p{
    color:grey !important;
}
.right-div-wrap-title{
    height: 42px !important;
    min-height: 21px;
    font-size: 16px;
    text-align: center;
    /* overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box; 
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;  */
}
.right-div-wrap-content{
    height: 38px;
    font-size: 14px;
    margin: 10px 0;
    text-align: center;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box; 
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
}
.right-div-wrap-div{
    display: inline-block;
    color: #fff;
    background: #3a8ee6;
    padding: 5px 20px;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin: 10px auto 0 !important;
}

</style>
